import React, { ReactElement } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

const useStylesAssetsOverview = makeStyles((theme: Theme) =>
  createStyles({
    totalCountBox: {
      flex: 1,
      display: 'flex',
      backgroundColor: '#5694DD',
      flexDirection: 'column',
      margin: 5,
      borderRadius: 5,
    },
    totalCountTitle: {
      color: '#fff',
      fontSize: '1rem',
      marginTop: 10,
      textAlign: 'center',
      height: '25px',
    },
    totalCount: {
      marginTop: 5,
      color: '#fff',
      fontSize: '2.7rem',
      textAlign: 'center',
      height: '55px',
    },
    titleAndCountContainer: {
      flex: 0.3,
      display: 'flex',
      flexDirection: 'column',
    },
    info: {
      fontSize: '.8rem',
      textAlign: 'center',
    },
  })
);
const WidgetTotalCountTile: React.FC<{
  title: String;
  count: number;
  bgColor: string;
  textColor: string;
  info?: string;
  goToScreen: string;
  testId: string;
  onClick?: () => void;
}> = ({
  title,
  count,
  bgColor,
  textColor,
  info,
  goToScreen,
  testId,
  onClick,
}): ReactElement => {
  const classes = useStylesAssetsOverview();
  const history = useHistory();

  const tileCountOnclick = () => {
    if (onClick) onClick();
    history.push('/' + goToScreen);
  };

  return (
    <div className={classes.totalCountBox} style={{ backgroundColor: bgColor }}>
      <div
        className={classes.titleAndCountContainer}
        onClick={tileCountOnclick}
      >
        <Typography
          className={classes.totalCountTitle}
          style={{ color: textColor }}
        >
          {title}
        </Typography>
        <Typography
          component="p"
          data-testid={testId}
          style={{ color: textColor }}
          className={classes.totalCount}
        >
          {count}
        </Typography>
      </div>
      <Typography className={classes.info} style={{ color: textColor }}>
        {info !== undefined ? info : null}
      </Typography>
    </div>
  );
};

export default WidgetTotalCountTile;
